import { render, staticRenderFns } from "./CompanyGroupList.vue?vue&type=template&id=04c86a97"
import script from "./CompanyGroupList.vue?vue&type=script&lang=js"
export * from "./CompanyGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports